import { useCallback } from 'react';
import { Dialog } from '@/components/ui/dialog';
import { CreateResaleItemForm } from './CreateResaleItemForm';

interface CreateResaleItemDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CreateResaleItemDialog({ open, onOpenChange }: CreateResaleItemDialogProps) {
  const handleClose = useCallback(() => onOpenChange(false), [onOpenChange]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {open && <CreateResaleItemForm onClose={handleClose} />}
    </Dialog>
  );
}
